<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-02-18 16:26:47
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-10 11:13:10
 * @FilePath: \huaxin-project-5\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app" :style="'background:#F6F8FC'">
    <div class="scale-wrapper" :style="transformStyle">
      <myHead v-show="!$route.meta.full" />
      <router-view />
      <myFooter v-show="!$route.meta.full"></myFooter>
      <RightSuspension v-show="!$route.meta.full"></RightSuspension>
    </div>
  </div>
</template>
<script>
import { GetSiteInfo } from "@/api/common";


import myHead from "@/components/head.vue";
import myFooter from "@/components/footer.vue";
import RightSuspension from "@/components/RightSuspension.vue";
export default {
  data() {
    return {
      scale: 1
    }
  },
  components: { myHead, myFooter, RightSuspension },
  created() {
    // 全屏 | 非必要登录 | 没有token 的时候不用获取用户信息
    GetSiteInfo().then((res) => {
      this.$store.state.siteInfo = res.data;
      this.$store.state.BusinessScope = JSON.parse(res.data.BusinessScope);
      localStorage.setItem("siteInfo", JSON.stringify(res.data));
    });
    if (this.$store.state.Token) {
      const originHref = localStorage.getItem("originHref");
      if (originHref) {
        localStorage.removeItem("originHref");
        if (!originHref.includes("/login")) {
          location.href = originHref;
        }
      }
      // this.$ajax.get('/Member/GetMemberInfo').then(({ data }) => {
      //   data.Avatar = this.webUrl + data.Avatar
      //   this.$store.state.userInfo = {
      //     ...this.$store.state.userInfo,
      //     ...data
      //   }
      // })
    } else {
      if (!location.href.includes("/login")) {
        localStorage.setItem("originHref", location.href);
      }
      // this.$router.replace({ path: "/" });
    }
  },
  computed: {
    transformStyle() {
      if (this.scale < 1) {
        return {
          zoom: this.scale,
          // transform: `z(${this.scale})`,
          width: '100%',
          height: '100%',
          display: 'inline-block' // 防止缩放后布局问题，根据实际情况调整
        };
      }

    }
  },
  mounted() {
    // 监听 hash 变化
    window.addEventListener("hashchange", this.handleHashChange, false);
    this.setScale();
    window.addEventListener('resize', this.setScale);
  },
  beforeDestroy() {
    // 移除事件监听，避免内存泄漏
    window.removeEventListener("hashchange", this.handleHashChange, false);
  },
  methods: {
    handleHashChange() {
      const currentPath = window.location.hash.slice(1); // 获取当前路径
      console.log("哈希变化");

      if (this.$route.path !== currentPath) {
        // 如果路由路径不一致，则手动跳转
        this.$router.push(currentPath);
      }
    },
    setScale() {
      // 设计稿的宽度（假设设计稿是1920px）
      const designWidth = 1480;
      // 当前窗口宽度
      const currentWidth = document.documentElement.clientWidth;
      // 计算缩放比例
      if (document.documentElement.clientWidth < 1100) {
        this.scale = currentWidth / designWidth;

      } else {
        this.scale = 1;
      }

      // 如果需要限制最小缩放比例，可以这样
      // const minScale = 0.5;
      // if (this.scale < minScale) {
      //   this.scale = minScale;
      // }
    }
  },
};
</script>
<style lang="scss"></style>